import './ChartDataMenu.css';
export var triggerButton = '_1hxr84t0-3-12-1';